import { useSearchParams } from 'next/navigation';
import { useRouter } from 'next/router';

import { ParsedUrlQuery } from 'node:querystring';

import { AppRouteParams } from '@klokhuis/core/Routing';

export const useUpdateQueryParams = () => {
  const router = useRouter();
  const searchParams = useSearchParams();
  const updateQueryParams = (additionalParams: ParsedUrlQuery) => {
    const updatedParams = { ...router.query, ...additionalParams };
    const queryString = new URLSearchParams(
      updatedParams as unknown as AppRouteParams,
    ).toString();

    window.history.replaceState({}, '', `?${queryString}`);
  };

  return { queryParams: searchParams, updateQueryParams };
};
